import React, { useRef, useState } from 'react';

import { withTextSelection } from '../../../hocs/withTextSelection';
import { handleCopyFormattedText } from '../../../helpers/handleCopyFormattedText';

import { NON_QUOTABLE_CLASS_NAME } from '../../../contexts/selectionContext';

import CopyAlert from '../../../design-system/CopyAlert/CopyAlert';
import NewRichTextArea from '../../../design-system/NewRichTextArea/NewRichTextArea';
import FormFieldWrapper from '../../../design-system/FormFieldWrapper/FormFieldWrapper';
import { ButtonIcon } from '../../../design-system';
import { FileCopyLineIcon } from '../../../design-system/Icons';

const FreeformContentField = ({
    value,
    label,
    id,
    state,
    feedbackAllowed,
    logFeedbackTrigger,
    setFormData,
    setErrorFormFields,
}) => {
    const ref = useRef(null);
    const [copyAlert, setCopyAlert] = useState(null);

    const handleFreeformChange = (id, value) => {
        setFormData((prevData) =>
            prevData.map((item) => (item.id === id ? { ...item, value } : item))
        );
        setErrorFormFields((prevData) => ({ ...prevData, [id]: false }));
    };

    const copyFormattedTextToClipboard = async () => {
        if (!ref.current) return;

        const node = ref.current.querySelector('._contentEditable_uazmk_379');
        if (node) {
            await handleCopyFormattedText({
                node,
                setCopyAlert,
                successMessage: `${label} copied to clipboard!`,
            });
        }
    };

    const actions = (
        <div className="flex items-center gap-2">
            {feedbackAllowed && logFeedbackTrigger}

            <ButtonIcon
                type="link"
                size="xs"
                state={!value ? 'disabled' : 'default'}
                icon={FileCopyLineIcon}
                onClick={copyFormattedTextToClipboard}
            />
        </div>
    );

    return (
        <div ref={ref}>
            <FormFieldWrapper
                label={<strong className={NON_QUOTABLE_CLASS_NAME}>{label}</strong>}
                showLabelAsBadge
                gap={8}
                value={value}
                state={state}
                errorMessage="Please fill in this field"
                actionsBarRightContent={actions}
            >
                <NewRichTextArea
                    value={value}
                    state={state}
                    placeholder="Write here"
                    setValue={(value) => handleFreeformChange(id, value)}
                    minHeight={20}
                    autoExpand
                />

                <CopyAlert copyAlert={copyAlert} setCopyAlert={setCopyAlert} />
            </FormFieldWrapper>
        </div>
    );
};

const QuotableFreeformContentField = withTextSelection(FreeformContentField);

const FeedbackAwareFreeformContentField = (props) => {
    const { feedbackAllowed } = props;

    if (feedbackAllowed) {
        return <QuotableFreeformContentField {...props} />;
    }

    return <FreeformContentField {...props} />;
};

export default FeedbackAwareFreeformContentField;
